import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#each (array @key)}}{{yield}}{{/each}}\n",{ moduleName: "sh-www/components/forced-rerender.hbs" })